import {plainActionGenerator} from 'utils';

export const setCurrentPlayingTimeAction = plainActionGenerator('SET_CURRENT_PLAYING_TIME');

export const toggleSummariesAction = plainActionGenerator('TOGGLE_SUMMARIES');